import { EBadgeType } from "@/common/badge/badge-helpers";
import { cn } from "@/utils/cn";
import { renderSwitch } from "@/utils/react-conditional";
import React from "react";

const BADGE_BASE_CLASS =
  "inline-block whitespace-nowrap rounded-[24px] bg-surface px-1.5 py-0.25 text-center text-small leading-[14px] font-medium text-title-color not-italic";

const BADGE_TYPE_CLASSES: Record<EBadgeType, string> = {
  [EBadgeType.New]:
    "rounded-r-none bg-pink px-1.5 py-0.5 text-small leading-[19px] font-semibold text-text-inverse tablet:px-2 tablet:py-1.25 tablet:text-body",
  [EBadgeType.Free]:
    "rounded-r-none bg-pink px-1.5 py-0.5 text-small leading-[19px] font-semibold text-text-inverse tablet:px-2 tablet:py-1.25 tablet:text-body",
  [EBadgeType.Vip]: "bg-[#fce185] text-[#8f710e]",
  [EBadgeType.Staff]: "bg-badge-dark text-text-inverse",
  [EBadgeType.NoCredits]: "bg-[#bcbcbc] text-text-inverse",
  [EBadgeType.PaidFan]:
    "border border-success bg-surface px-1.25 py-0 text-success",
  [EBadgeType.Fan]: "bg-[#61b47f] text-text-inverse",
  [EBadgeType.Bonus]: "bg-[#47b0f5] text-text-inverse",
  [EBadgeType.Subscriber]: "bg-[#e35b6f] text-text-inverse",
};

function badgeClassName(type?: EBadgeType) {
  return cn(BADGE_BASE_CLASS, type && BADGE_TYPE_CLASSES[type]);
}

export const Badge = React.memo(function Badge(props: { type?: EBadgeType }) {
  return (
    <>
      {renderSwitch(
        props.type!,
        {
          // DISCOVER
          [EBadgeType.New]: () => (
            <span className={badgeClassName(props.type)}>NEW</span>
          ),
          [EBadgeType.Free]: () => (
            <span className={badgeClassName(props.type)}>FREE CHAT</span>
          ),
          // PROFILE
          [EBadgeType.Vip]: () => (
            <span className={badgeClassName(props.type)}>VIP</span>
          ),
          [EBadgeType.Staff]: () => (
            <span className={badgeClassName(props.type)}>Staff</span>
          ),
          [EBadgeType.NoCredits]: () => (
            <span className={badgeClassName(props.type)}>No Credits</span>
          ),
          [EBadgeType.PaidFan]: () => (
            <span className={badgeClassName(props.type)}>Paid</span>
          ),
          [EBadgeType.Fan]: () => (
            <span className={badgeClassName(props.type)}>Your Fan</span>
          ),
          [EBadgeType.Bonus]: () => (
            <span className={badgeClassName(props.type)}>Bonus Chat</span>
          ),
          [EBadgeType.Subscriber]: () => (
            <span className={badgeClassName(props.type)}>
              Subscriber &hearts;
            </span>
          ),
        },
        () => null
      )}
    </>
  );
});
